import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface Manufacturer {
    manufacturerId: string;
    manufacturerName: string;
    icon: string;
    active: boolean;
}

export interface Category {
    categoryId: string;
    categoryName: string;
}

export interface Model {
    modelId: string;
    model: string;
    manufacturerId: string;
    categoryId: string;
    version: string;
    coverages: { [key: string]: string };
    compatability: string;
    searchTags: string[];
    deviceId: string;
    active: boolean;
}

export enum Sides {
    Back = 'Back',
    Front = 'Front',
}

export interface Coverage {
    coverageId: string;
    coverageName: string;
    active: boolean;
    languageCode: string;
    facing: Sides;
    isCase: boolean;
    compatability: string;
}

export interface DesignState {
    manufacturers: Manufacturer[];
    models: Model[];
    coverages: Coverage[];
    categories: Category[];
}

const initialState: DesignState = {
    manufacturers: [],
    models: [],
    coverages: [],
    categories: [],
};

const designSlice = createSlice({
    name: 'design',
    initialState,
    reducers: {
        setManufacturers: (state, action: PayloadAction<Manufacturer[]>) => {
            state.manufacturers = action.payload;
        },
        setModels: (state, action: PayloadAction<Model[]>) => {
            state.models = action.payload;
        },
        setCoverages: (state, action: PayloadAction<Coverage[]>) => {
            state.coverages = action.payload;
        },
        setCategories: (state, action: PayloadAction<Category[]>) => {
            state.categories = action.payload;
        }
    },
});

export const { setManufacturers, setModels, setCoverages, setCategories } = designSlice.actions;

export default designSlice.reducer;
